<app-user-avatar
  [firstName]="form.controls['firstName'].value"
  [lastName]="form.controls['lastName'].value"
/>

<mat-divider />

<h3 class="user-profile__form-title">
  {{ 'user-profile.general.accountInformation.title' | translate }}
</h3>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="user-profile__inputs">
    <div class="user-profile__input-wrapper">
      @let firstNameControl = getFormControl('firstName');
      <mat-label>
        {{ 'user-profile.general.accountInformation.firstName' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="firstNameControl"
          placeholder="Max"
          type="text"
          maxlength="30"
        />
        @if (
          firstNameControl.hasError('required') &&
          (firstNameControl.dirty || firstNameControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.emptyField' | translate }}
          </mat-error>
        }
        @if (
          firstNameControl.hasError('invalidName') &&
          (firstNameControl.dirty || firstNameControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.firstName' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let lastNameFormControl = getFormControl('lastName');
      <mat-label>
        {{ 'user-profile.general.accountInformation.lastName' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="lastNameFormControl"
          placeholder="Kunytsia"
          type="text"
          maxlength="30"
        />
        @if (
          lastNameFormControl.hasError('required') &&
          (lastNameFormControl.dirty || lastNameFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.emptyField' | translate }}
          </mat-error>
        }
        @if (
          lastNameFormControl.hasError('invalidName') &&
          (lastNameFormControl.dirty || lastNameFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.lastName' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let emailFormControl = getFormControl('email');
      <mat-label>
        {{ 'user-profile.general.accountInformation.email' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="emailFormControl"
          placeholder="email@gmail.com"
          type="email"
        />
        @if (
          emailFormControl.hasError('required') &&
          (emailFormControl.dirty || emailFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.emptyField' | translate }}
          </mat-error>
        }
        @if (
          emailFormControl.hasError('invalidEmail') &&
          (emailFormControl.dirty || emailFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.email' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let phoneFormControl = getFormControl('phoneNumber');
      <mat-label>
        {{ 'user-profile.general.accountInformation.phone' | translate }}
      </mat-label>
      <div
        class="phone-field"
        [class.has-error]="hasPhoneError"
        [class.is-focused]="isPhoneFocused()"
      >
        <mat-form-field appearance="outline" class="phone-field__country">
          <mat-select
            formControlName="phoneCountryId"
            (focus)="onPhoneFocus()"
            (blur)="onPhoneBlur()"
          >
            <mat-select-trigger>
              <span class="phone-field__country-code">
                {{ getCountryCode() }} ({{ getPhoneCode() }})
              </span>
            </mat-select-trigger>
            @for (country of countries().data; track country.id) {
              <mat-option [value]="country.name">
                <span>{{ country.name }} ({{ country.phoneCode }})</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="phone-field__number">
          @if (phonePrefix()) {
            <span matTextPrefix class="phone-field__prefix">{{ phonePrefix() }}</span>
          }
          <input
            matInput
            [formControl]="phoneFormControl"
            [placeholder]="phoneMask"
            type="tel"
            [mask]="phoneMask"
            (focus)="onPhoneFocus()"
            (blur)="onPhoneBlur()"
          />
        </mat-form-field>
      </div>
      @if (hasPhoneError) {
        <div class="phone-field__error">
          {{ 'user-profile.general.errors.phone' | translate }}
        </div>
      }
    </div>

    <div class="user-profile__input-wrapper">
      @let shippingAddressControl = getFormControl('shippingAddress');
      <mat-label>
        {{ 'user-profile.general.accountInformation.shippingAddress' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="shippingAddressControl"
          placeholder="190 Upor Bazar, Natore Sadar, Natore"
          type="text"
        />
        @if (
          shippingAddressControl.hasError('required') &&
          (shippingAddressControl.dirty || shippingAddressControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.emptyField' | translate }}
          </mat-error>
        }
        @if (
          shippingAddressControl.hasError('invalidShippingAddress') &&
          (shippingAddressControl.dirty || shippingAddressControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.shippingAddress' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let countryIdControl = getFormControl('countryId');
      <mat-label>
        {{ 'user-profile.general.accountInformation.country' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="countryIdControl">
          <mat-select-trigger>
            <span class="user-profile__country">{{ countryIdControl.value }}</span>
          </mat-select-trigger>
          @for (country of countries().data; track country.id) {
            <mat-option [value]="country.name">{{ country.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let cityFormControl = getFormControl('city');
      <mat-label>
        {{ 'user-profile.general.accountInformation.city' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput [formControl]="cityFormControl" placeholder="Natore" type="text" />
        @if (
          cityFormControl.hasError('required') && (cityFormControl.dirty || cityFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.emptyField' | translate }}
          </mat-error>
        }
        @if (
          cityFormControl.hasError('invalidCity') &&
          (cityFormControl.dirty || cityFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.city' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let stateFormControl = getFormControl('state');
      <mat-label>
        {{ 'user-profile.general.accountInformation.state' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput [formControl]="stateFormControl" placeholder="Rajshahi" />
        @if (
          stateFormControl.hasError('required') &&
          (stateFormControl.dirty || stateFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.emptyField' | translate }}
          </mat-error>
        }
        @if (
          stateFormControl.hasError('invalidState') &&
          (stateFormControl.dirty || stateFormControl.touched)
        ) {
          <mat-error>
            {{ 'user-profile.general.errors.state' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="user-profile__input-wrapper">
      @let zipFormControl = getFormControl('zipCode');
      <mat-label>
        {{ 'user-profile.general.accountInformation.zip' | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        @if (zipPrefix()) {
          <span matTextPrefix class="zip-field__prefix">{{ zipPrefix() }}</span>
        }
        <input matInput [formControl]="zipFormControl" [placeholder]="zipMask" [mask]="zipMask" />
        @if (zipFormControl.invalid && (zipFormControl.dirty || zipFormControl.touched)) {
          <mat-error>
            {{ 'user-profile.general.errors.zip' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="user-profile__btn-wrapper">
    @if (dataSaved()) {
      <div class="user-profile__save-request">
        {{ 'shop-settings.general.buttonsInteraction.successRequest' | translate }}
      </div>
    }
    <button type="button" class="btn-white user-profile__btn-cancel" (click)="cancelDataChange()">
      {{ 'user-profile.general.buttons.cancel' | translate }}
    </button>
    <button type="submit" class="btn-primary">
      {{ 'user-profile.general.buttons.save' | translate }}
    </button>
  </div>
</form>
